/**
 * Created by andreyna on 11/09/2017.
 */
export const GAME_ITEM_CLASSES = {
    GAME_THUMBNAIL_CLASS: 'cgp-game-item-thumbnail',
    GAME_JACKPOT_CONTAINER_CLASS: 'cgp-game-item-jackpot-container',
    GAME_ITEM_CONTAINER: 'cgp-game-item-container',
    GAME_ITEM_PLAY_BTN: 'cgp-game-play-btn',
    GAME_ITEM_BTN_FONT: 'cgp-theme-property-font-type-4',
    GAME_ITEM_BTN_AREA: 'cgp-game-item-buttons-area',
    GAME_ITEM_DEFAULT_BTN_CLASS: 'cgp-themes-3rd-cta'
};
